var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-btn', _vm._g(_vm._b({
    staticClass: "tool-next"
  }, 'v-btn', _vm.props, false), {
    click: _vm.click
  }), [_c('span', [_c('span', [_vm._v(" 다음 ")]), _c('span', {
    staticClass: "d-none d-lg-inline"
  }, [_vm._v(" " + _vm._s(_vm.typeText) + " ")])]), _vm.isDone ? [_c('v-icon', [_vm._v(" " + _vm._s(_vm.icon) + " ")])] : [_c('v-icon', {
    staticStyle: {
      "color": "white!important"
    }
  }, [_vm._v(" " + _vm._s(_vm.icon) + " ")])]], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }